import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import styles from '../QBRDocumentsFilterArea.module.scss'

export interface IMyQBRDropdownProps {
  isOnlyLegacy: boolean
  onChangeIsOnlyLegacy: (value: boolean) => void
}

export const OnlyLegacyCheckbox = ({ isOnlyLegacy, onChangeIsOnlyLegacy }: IMyQBRDropdownProps) => {
  const onIsLegacyChange = useCallback(() => {
    onChangeIsOnlyLegacy(!isOnlyLegacy)
  }, [isOnlyLegacy, onChangeIsOnlyLegacy])

  return (
    <div className={styles.filter}>
      <Checkbox
        label={<Translation text={TRANSLATION_KEYS.tableFilters.onlyLegacy} />}
        checked={isOnlyLegacy}
        onChange={onIsLegacyChange}
      />
    </div>
  )
}
